import { render, staticRenderFns } from "./ModalCadastroComponente.vue?vue&type=template&id=76fac4fb"
import script from "./ModalCadastroComponente.vue?vue&type=script&lang=js"
export * from "./ModalCadastroComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports